import { render, staticRenderFns } from "./templateList.vue?vue&type=template&id=38a8de2c&scoped=true"
import script from "./templateList.vue?vue&type=script&lang=js"
export * from "./templateList.vue?vue&type=script&lang=js"
import style0 from "./templateList.vue?vue&type=style&index=0&id=38a8de2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a8de2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a8de2c')) {
      api.createRecord('38a8de2c', component.options)
    } else {
      api.reload('38a8de2c', component.options)
    }
    module.hot.accept("./templateList.vue?vue&type=template&id=38a8de2c&scoped=true", function () {
      api.rerender('38a8de2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/list/templateList.vue"
export default component.exports